import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,

} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PublicIcon from '@mui/icons-material/Public';
import { motion } from 'framer-motion';
import AnimatedSection from '../components/AnimatedSection';

function About() {
  return (
    <Container maxWidth="lg">
      {/* Hero Section with Image */}
      <AnimatedSection animation="fadeIn">
      <Box sx={{
        position: 'relative',
        textAlign: 'center',
        my: 4,
        py: 8,
        background: `
          linear-gradient(135deg, rgba(0, 100, 0, 0.8), rgba(46, 125, 50, 0.8)),
          url('/meeting.jpg')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        borderRadius: 4,
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1
        }
      }}>
        <Box sx={{ position: 'relative', zIndex: 2 }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              mb: 2
            }}
          >
            About Us
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            paragraph
            sx={{
              color: 'white',
              opacity: 0.9,
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
              maxWidth: 800,
              mx: 'auto'
            }}
          >
            The Lagos Impact Hackathon (LIH) is an innovation summit designed to accelerate technology-driven solutions for some of Nigeria’s most pressing socio-economic and environmental challenges.
          </Typography>
        </Box>
      </Box>
      </AnimatedSection>

      <Grid container spacing={4} sx={{ mb: 6 }}>
        <Grid item xs={12} md={6}>
          <AnimatedSection animation="slideRight" delay={0.2}>
          <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.3 }}>
          <Card sx={{
            height: '100%',
          }}>
            <CardMedia
              component="img"
              height="200"
              image="/meeting.jpg"
              alt="UNDP Partnership"
            />
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PublicIcon sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="h5" component="h3">
                  Partnership with UNDP
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                Lagos Impact Hackathon is held in strategic partnership with the United Nations Development Programme (UNDP),
                ensuring our initiatives align with global sustainable development goals.
              </Typography>
            </CardContent>
          </Card>
          </motion.div>
          </AnimatedSection>
        </Grid>

        <Grid item xs={12} md={6}>
          <AnimatedSection animation="slideLeft" delay={0.3}>
          <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.3 }}>
          <Card sx={{
            height: '100%',
          }}>
            <CardMedia
              component="img"
              height="200"
              image="/teamwork.jpg"
              alt="Lagos Impact Hackathon"
            />
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <GroupIcon sx={{ mr: 1, color: 'secondary.main' }} />
                <Typography variant="h5" component="h3">
                  Lagos Impact Hackathon
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                We bring together 200+ of Nigeria's most elite, pre-vetted talents - developers, marketers, and innovators
                who are committed to driving real change in our communities.
              </Typography>
            </CardContent>
          </Card>
          </motion.div>
          </AnimatedSection>
        </Grid>
      </Grid>

                  <AnimatedSection animation="slideUp" delay={0.3}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          About Us
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          The Lagos Impact Hackathon (LIH) is an innovation summit designed to accelerate technology-driven solutions for some of Nigeria's most pressing socio-economic and environmental challenges.
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          More than a typical hackathon, LIH is a venture-building platform built to bridge one of Africa's most critical innovation gaps: the divide between a great idea and its real-world adoption. Through an integrated ecosystem of technology partners, Web3 innovators, blockchain protocols, and strategic experts, LIH brings together the talent and resources needed to build working solutions with a credible pathway to real-world adoption and measurable community impact.
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          Each edition of LIH is designed as a collaborative ecosystem where innovators, policy leaders, and development partners co-create interventions that can be incubated and scaled post-event.
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          Ultimately, the Lagos Impact Hackathon is more than an event. It is a movement that inspires hope and optimism, reimagining how innovation, collaboration, and impact can converge to shape the future of sustainable development in Nigeria and beyond.
        </Typography>
      </Box>
      </AnimatedSection>

      <AnimatedSection animation="fadeIn" delay={0.4}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          To serve as Nigeria's leading impact integrator, convening, connecting, and catalyzing the nation's most vital forces for good.
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          We merge global policy insights, cutting-edge Web3 and blockchain technology, and Nigeria's brightest talent to deliver solutions that are scalable, sustainable, and built for real-world adoption.
        </Typography>
      </Box>
      </AnimatedSection>

      <AnimatedSection animation="scale" delay={0.5}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Our Vision
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
          To be Nigeria's most trusted pipeline for turning high-impact ideas into real, funded, and sustainable ventures.
        </Typography>
      </Box>
      </AnimatedSection>


    </Container>
  );
}

export default About;
